import React, { useState } from 'react';
import globalStyles from 'assets/stylesheets/global-styles.module.scss';
import { useParams } from 'react-router-dom';
import { Notification } from 'common/notification';
import { Footer, FooterType } from 'common/footer';
import { getQueryParam } from 'helpers/utils';
import styles from './reset-password.module.scss';
import { ResetPasswordStep1, ResetPasswordStep2 } from './sections';

type ParamType = {
  token: string;
};

const ResetPassword: React.FC = () => {
  const { token } = useParams<ParamType>();
  const email = getQueryParam('email') ?? '';
  const name = getQueryParam('name') ?? '';

  const [step, setStep] = useState(0);
  const [showError, setShowError] = useState(false);

  const showForgotPasswordStep1View = () => (
    <ResetPasswordStep1
      tokenUser={token}
      notifSuccess={() => setStep(1)}
      email={email}
      userName={name}
    />
  );

  const showForgotPasswordStep2View = () => <ResetPasswordStep2 />;

  const showContentView = () => (
    <div className={globalStyles.signBoxContent}>
      <div className={styles.elements}>
        {step === 0 && showForgotPasswordStep1View()}
        {step === 1 && showForgotPasswordStep2View()}
      </div>
    </div>
  );

  const showErrorNotification = () => (
    <Notification handleClose={() => setShowError(false)} />
  );

  return (
    <div className={globalStyles.container}>
      {showError && showErrorNotification()}
      <div className={styles.content}>
        <div className={styles.contentFormWrapper}>{showContentView()}</div>
        <div className={styles.contentFooter}>
          <Footer footerType={FooterType.NoSignedUser} />
        </div>
      </div>
    </div>
  );
};

export { ResetPassword };
